import { render, staticRenderFns } from "./PreScreenGender.vue?vue&type=template&id=0c828306"
import script from "./PreScreenGender.vue?vue&type=script&lang=js"
export * from "./PreScreenGender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports